import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder, UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';
import { BehaviorSubject, Observable, map, shareReplay, tap } from 'rxjs';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import {CommonModule, NgFor, NgIf} from "@angular/common";
import {TypeaheadMatch, TypeaheadModule} from "ngx-bootstrap/typeahead";
import {ShipmentPrefAddress, StateCountry} from "../../../shared/common-components/common-structure";
import {RatesSroMasterService} from "../../../services/rates-sro-master/rates-sro-master.service";
import {StateCountryService} from "../../../services/state-country/state-country.service";
import {CommonValidators} from "../../../shared/common-components/common-validators";
import {filter, takeWhile} from "rxjs/operators";
import {NameAndAddressService} from "../../../services/name-and-address/name-and-address.service";
import {TabsModule} from "ngx-bootstrap/tabs";


@Component({
  selector: 'app-frt-oto-rate-query-addresses',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    BsDatepickerModule,
    TimepickerModule,
    TypeaheadModule,
    TabsModule,
    CommonModule,
    NgFor, NgIf],
  templateUrl: './frt-oto-rate-query-addresses.component.html',
  styleUrl: './frt-oto-rate-query-addresses.component.css'
})
export class FrtOtoRateQueryAddressesComponent implements OnInit, OnDestroy {
  observer$ = new BehaviorSubject(true);
  originDestinationData;
  isFormInvalidValue = [];
  public activeTab: string;
  addressOriginForm: UntypedFormGroup;
  addressShipperForm: UntypedFormGroup;
  addressBillToForm: UntypedFormGroup;
  addressDestinationForm: UntypedFormGroup;
  addressConsigneeForm: UntypedFormGroup;
  issuingOfficeForm: UntypedFormGroup;
  dataShipperSearchAddressResults$: Observable<any>;
  dataOriginSearchAddressResults$: Observable<any>;
  dataBillToSearchAddressResults$: Observable<any>;
  dataDestinationSearchAddressResults$: Observable<any>;
  dataConsigneeSearchAddressResults$: Observable<any>;
  @Output()
  emitData: EventEmitter<any> = new EventEmitter();
  private defaultCountry = new BehaviorSubject<StateCountry>(null);
  states;
  allCountriesFrtList$ = this.stateCountryService.getAllCountries().pipe(
    map(stateCountries => stateCountries.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1 && (country.parentCountryId === 326)) ),
    tap((allCountries) => {
      const defaultOrigin = allCountries.find(x => {
        return x.stateCountryCode === 'US00';
      });
      this.defaultCountry.next(defaultOrigin);
    }),
    shareReplay(1)
  );

  constructor(private ratesSroMasterService: RatesSroMasterService, private bsModalRef: BsModalRef, public options: ModalOptions,
    private formBuilder: UntypedFormBuilder, private nameAndAddressService: NameAndAddressService, private stateCountryService: StateCountryService) {
    this.dataOriginSearchAddressResults$ = Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          this.addressOriginForm.get('searchString').value
        )
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
    this.dataShipperSearchAddressResults$ = Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          this.addressShipperForm.get('searchString').value
        )
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
    this.dataBillToSearchAddressResults$ = Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          this.addressBillToForm.get('searchString').value
        )
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
    this.dataDestinationSearchAddressResults$ = Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          this.addressDestinationForm.get('searchString').value
        )
        .subscribe((result: any) => {
          observer.next(result);
        });
    });

    this.dataConsigneeSearchAddressResults$ = Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          this.addressConsigneeForm.get('searchString').value
        )
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
  }

  typeaheadShipperOnSelect(e: TypeaheadMatch, recordType: string): void {
    const uspsCity = e.item;
    const state = this.states.find(stateDetails => {
      return stateDetails.stateCountryCode2Digit === uspsCity.stateAbbrev;
    });
    switch (recordType) {
      case "origin":
        this.addressOriginForm.get('uspsCity').setValue(e.item);
        this.addressOriginForm.get('city').setValue(uspsCity.cityName);
        this.addressOriginForm.get('state').setValue(uspsCity.stateAbbrev);
        this.addressOriginForm.get('zipCode').setValue(uspsCity.zipCode);
        this.addressOriginForm.get('stateId').setValue(state ? state.stateCountryId : undefined);
        break;
      case "shipper":
        this.addressShipperForm.get('uspsCity').setValue(e.item);
        this.addressShipperForm.get('city').setValue(uspsCity.cityName);
        this.addressShipperForm.get('state').setValue(uspsCity.stateAbbrev);
        this.addressShipperForm.get('zipCode').setValue(uspsCity.zipCode);
        this.addressShipperForm.get('stateId').setValue(state ? state.stateCountryId : undefined);
        break;
      case "billTo":
        this.addressBillToForm.get('uspsCity').setValue(e.item);
        this.addressBillToForm.get('city').setValue(uspsCity.cityName);
        this.addressBillToForm.get('state').setValue(uspsCity.stateAbbrev);
        this.addressBillToForm.get('zipCode').setValue(uspsCity.zipCode);
        this.addressBillToForm.get('stateId').setValue(state ? state.stateCountryId : undefined);
        break;
      case "destination":
        this.addressDestinationForm.get('uspsCity').setValue(e.item);
        this.addressDestinationForm.get('city').setValue(uspsCity.cityName);
        this.addressDestinationForm.get('state').setValue(uspsCity.stateAbbrev);
        this.addressDestinationForm.get('zipCode').setValue(uspsCity.zipCode);
        this.addressDestinationForm.get('stateId').setValue(state ? state.stateCountryId : undefined);
        break;
      case "consignee":
        this.addressConsigneeForm.get('uspsCity').setValue(e.item);
        this.addressConsigneeForm.get('city').setValue(uspsCity.cityName);
        this.addressConsigneeForm.get('state').setValue(uspsCity.stateAbbrev);
        this.addressConsigneeForm.get('zipCode').setValue(uspsCity.zipCode);
        this.addressConsigneeForm.get('stateId').setValue(state ? state.stateCountryId : undefined);
        break;
      default:
        break;
    }
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
    }

  /**
   * @description initializes the form and gets all the accessorials
   */
  ngOnInit() {
    this.originDestinationData = this.options.initialState;
    console.log(this.originDestinationData);
    this.initializeForm();
    this.nameAndAddressService.allStates$.subscribe(res => {
      this.states = res;
    });
    this.defaultCountry
      .pipe(filter(value => value != null))
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(defaultCountry => {
        this.addressOriginForm.get('countryId').setValue(defaultCountry.stateCountryId, {emitEvent: false, onlySelf: false});
        this.addressShipperForm.get('countryId').setValue(defaultCountry.stateCountryId, {emitEvent: false, onlySelf: false});
        this.addressBillToForm.get('countryId').setValue(defaultCountry.stateCountryId, {emitEvent: false, onlySelf: false});
        this.addressDestinationForm.get('countryId').setValue(defaultCountry.stateCountryId, {emitEvent: false, onlySelf: false});
        this.addressConsigneeForm.get('countryId').setValue(defaultCountry.stateCountryId, {emitEvent: false, onlySelf: false});
      });
    this.addressOriginForm.get('city').setValue(this.originDestinationData.origin.cityName);
    this.addressOriginForm.get('state').setValue(this.originDestinationData.origin.stateAbbrev);
    this.addressOriginForm.get('zipCode').setValue(this.originDestinationData.origin.zipCode);
    this.addressOriginForm.get('stateId').setValue(this.originDestinationData.origin.stateCountryId);
    this.addressOriginForm.get('uspsCity').setValue(this.originDestinationData.origin.uspsCity);
    this.addressDestinationForm.get('city').setValue(this.originDestinationData.destination.cityName);
    this.addressDestinationForm.get('state').setValue(this.originDestinationData.destination.stateAbbrev);
    this.addressDestinationForm.get('zipCode').setValue(this.originDestinationData.destination.zipCode);
    this.addressDestinationForm.get('stateId').setValue(this.originDestinationData.destination.stateCountryId);
    this.addressDestinationForm.get('uspsCity').setValue(this.originDestinationData.destination.uspsCity);
  }



  /**
   * @description initializes frt query form.
   */
  initializeForm() {
    this.addressOriginForm = this.formBuilder.group({
      addressLine1: new UntypedFormControl('', [Validators.required]),
      addressLine2: new UntypedFormControl('', [Validators.maxLength(100), Validators.required]),
      searchString: new UntypedFormControl(''),
      uspsCity: new UntypedFormControl({ value: '', disabled: true }),
      city: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(45), Validators.required]),
      state: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      stateId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      zipCode: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(6), CommonValidators.numeric, Validators.required]),
      countryId: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required]),
      phoneExt: new UntypedFormControl('', [Validators.maxLength(10)]),
      emailAddress: new UntypedFormControl('', [Validators.maxLength(45), CommonValidators.email, Validators.required]),
      alternatePhone: new UntypedFormControl('', [Validators.minLength(10), Validators.maxLength(20)]),
      otherContactInfo: new UntypedFormControl(''),
    });
    this.addressShipperForm = this.formBuilder.group({
      addressLine1: new UntypedFormControl('', [Validators.required]),
      addressLine2: new UntypedFormControl('', [Validators.maxLength(100), Validators.required]),
      searchString: new UntypedFormControl(''),
      uspsCity: new UntypedFormControl({ value: '', disabled: true }),
      city: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(45), Validators.required]),
      state: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      stateId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      zipCode: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(6), CommonValidators.numeric, Validators.required]),
      countryId: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required]),
      phoneExt: new UntypedFormControl('', [Validators.maxLength(10)]),
      emailAddress: new UntypedFormControl('', [Validators.maxLength(45), CommonValidators.email, Validators.required]),
      alternatePhone: new UntypedFormControl('', [Validators.minLength(10), Validators.maxLength(20)]),
      otherContactInfo: new UntypedFormControl(''),
    });
    this.addressBillToForm = this.formBuilder.group({
      addressLine1: new UntypedFormControl(''),
      addressLine2: new UntypedFormControl('', [Validators.maxLength(100)]),
      searchString: new UntypedFormControl(''),
      uspsCity: new UntypedFormControl({ value: '', disabled: true }),
      city: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(45), Validators.required]),
      state: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      stateId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      zipCode: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(6), CommonValidators.numeric, Validators.required]),
      countryId: new UntypedFormControl(''),
      phone: new UntypedFormControl(''),
      phoneExt: new UntypedFormControl('', [Validators.maxLength(10)]),
      emailAddress: new UntypedFormControl('', [Validators.maxLength(45), CommonValidators.email, Validators.required]),
      alternatePhone: new UntypedFormControl('', [Validators.minLength(10), Validators.maxLength(20)]),
      otherContactInfo: new UntypedFormControl(''),
    });
    this.addressDestinationForm = this.formBuilder.group({
      addressLine1: new UntypedFormControl('', [Validators.required]),
      addressLine2: new UntypedFormControl('', [Validators.maxLength(100), Validators.required]),
      searchString: new UntypedFormControl(''),
      uspsCity: new UntypedFormControl({ value: '', disabled: true }),
      city: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(45), Validators.required]),
      state: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      stateId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      zipCode: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(6), CommonValidators.numeric, Validators.required]),
      countryId: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required]),
      phoneExt: new UntypedFormControl('', [Validators.maxLength(10)]),
      emailAddress: new UntypedFormControl('', [Validators.maxLength(45), CommonValidators.email, Validators.required]),
      alternatePhone: new UntypedFormControl('', [Validators.minLength(10), Validators.maxLength(20)]),
      otherContactInfo: new UntypedFormControl(''),
    });
    this.addressConsigneeForm = this.formBuilder.group({
      addressLine1: new UntypedFormControl('', [Validators.required]),
      addressLine2: new UntypedFormControl('', [Validators.maxLength(100), Validators.required]),
      searchString: new UntypedFormControl(''),
      uspsCity: new UntypedFormControl({ value: '', disabled: true }),
      city: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(45), Validators.required]),
      state: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      stateId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      zipCode: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(6), CommonValidators.numeric, Validators.required]),
      countryId: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required]),
      phoneExt: new UntypedFormControl('', [Validators.maxLength(10)]),
      emailAddress: new UntypedFormControl('', [Validators.maxLength(45), CommonValidators.email, Validators.required]),
      alternatePhone: new UntypedFormControl('', [Validators.minLength(10), Validators.maxLength(20)]),
      otherContactInfo: new UntypedFormControl(''),
    });
    this.issuingOfficeForm = this.formBuilder.group({
      nameAddressId: new UntypedFormControl(''),
      shipmentsId: new UntypedFormControl(''),
      shipmentPrefAddressesId: new UntypedFormControl(''),
      firstName: new UntypedFormControl('', [Validators.maxLength(45), Validators.required]),
      lastName: new UntypedFormControl('', [Validators.maxLength(45), Validators.required]),
      middleInitial: new UntypedFormControl('', [Validators.maxLength(1)]),
      phone: new UntypedFormControl('', [Validators.required]),
      issuingOfficerTitle: new UntypedFormControl('', [Validators.maxLength(45), Validators.required]),
      issuingOfficeName: new UntypedFormControl('', [Validators.maxLength(45), Validators.required])
    });
  }

  onSelectTab($event) {
    if ($event.heading === 'FRT View Rates') {
      this.activeTab = 'zero';
    } else if ($event.heading === 'FRT Template Download') {
      this.activeTab = 'one';
    } else if ($event.heading === 'FRT Upload Rate File') {
      this.activeTab = 'two';
    } else if ($event.heading === 'FRT Edit Rates') {
      this.activeTab = 'three';
    } else if ($event.heading === 'FRT Global Update') {
      this.activeTab = 'four';
    }
  }

  typeaheadAddressOnSelect($event) {
    const selectedAddress: ShipmentPrefAddress = $event.item;
    this.addressOriginForm.get('addressLine1').setValue(selectedAddress.addressLine1);
    this.addressOriginForm.get('addressLine2').setValue(selectedAddress.addressLine2);
    this.addressOriginForm.get('emailAddress').setValue(selectedAddress.emailAddress);
    this.addressOriginForm.get('firstName').setValue(selectedAddress.firstName);
    this.addressOriginForm.get('lastName').setValue(selectedAddress.lastName);
    this.addressOriginForm.get('middleInitial').setValue(selectedAddress.middleInitial);
    this.addressOriginForm.get('otherContactInfo').setValue(selectedAddress.otherContactInfo);
    this.addressOriginForm.get('phone').setValue(selectedAddress.phone);
    this.addressOriginForm.get('phoneExt').setValue(selectedAddress.phoneExt);
  }

  submit() {
    this.bsModalRef.hide();
    this.emitData.next({
      origin: this.addressOriginForm.value,
      billTo: this.addressBillToForm.value,
      shipper: this.addressShipperForm.value,
      destination: this.addressDestinationForm.value,
      consignee: this.addressConsigneeForm.value,
      issuingOffice: this.issuingOfficeForm.value
    });
  }

  isSubmitDisable() {
    this.isFormInvalidValue = [];
    if (!this.addressOriginForm.valid) {
      this.isFormInvalidValue.push('Origin')
    }
    if (!this.addressShipperForm.valid) {
      this.isFormInvalidValue.push('Shipper')
    }
    if (!this.addressBillToForm.valid) {
      this.isFormInvalidValue.push('Bill To')
    }
    if (!this.addressDestinationForm.valid) {
      this.isFormInvalidValue.push('Destination')
    }
    if (!this.addressConsigneeForm.valid) {
      this.isFormInvalidValue.push('Consignee')
    }
    if (!this.issuingOfficeForm.valid) {
      this.isFormInvalidValue.push('Issuing Office')
    }
    return this.isFormInvalidValue.length > 0;
  }
}
